import { Alert, Backdrop, Box, Button, ButtonProps, CircularProgress, DialogActions, DialogContent, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, styled, TextField, Typography } from "@mui/material";
import _ from "lodash";
import React, { ChangeEvent, ElementType, useState } from "react";
import { loadOptionForCustomer, loadOptionsForSprint, OptionsStore } from "../../common/OptionsLoader";
import CustomDatePicker from "../../common/CustomDatePicker";
import { useNavigate } from 'react-router-dom';
import useExcelImport from "./import.leads.hooks";
import AutoLayout from "../../../components/AutoLayout";
import ExcelImportStore from "./ExcelImportStore";

type Props = {
    importing: boolean,
    onClose: (cancelled: boolean) => void,
}



const ExcelImportDetails = ({ onClose, importing }: Props) => {
    const { saveRecords, loadWorkbook, session, unmappedColumns, customers, stages, customerSprints, sprintCadences, onSave, setCustomerSprints, setSprintCadences } = useExcelImport();
    const [saving, setSaving] = useState(false);

    const [errorOccured, setErrorOccured] = React.useState(false)
    const navigate = useNavigate();
    
    React.useEffect(() => {
        const loadOptions = async () => {
            const response = await loadOptionForCustomer('sprint', session.customerId);
            setCustomerSprints(response);
        }

        loadOptions();
    }, [session.customerId])

    React.useEffect(() => {
        const loadOptions = async () => {
            const response = await loadOptionsForSprint(session.sprintId);
            setSprintCadences(response);
        }

        loadOptions();
    }, [session.sprintId])


    const handleSave = async () => {
        setSaving(true);
        var success = await onSave();
        if (success) {
            await saveRecords();

            setSaving(false);
            onClose(true);
        } else {
            setSaving(false);
            setErrorOccured(true);
        }
    }

    const onCancel = () => {
        if (importing) {
            onClose(false);
            return;
        }

        onClose(false);
    }

    if (stages.length === 0) return (<AutoLayout title="Import Leads (Excel)" onFinish={handleSave} onCancel={onCancel}>
        <Alert severity="error" sx={{ mb: 2 }}>Error: could not load lead stages.</Alert>
    </AutoLayout>);

    return (
        <AutoLayout title="Import Leads (Excel)" onFinish={handleSave} onCancel={onCancel}>
            {saving && <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={saving}
            >
                <CircularProgress color="inherit" />
            </Backdrop>}

            <Grid container rowGap={2}>
                <Grid xs={12}>
                    {errorOccured && <Alert severity="error" sx={{ mb: 2 }}>Error: please see below for more details.</Alert>}
                    {!importing && <Typography variant="body2">You will be able to change your answers before commiting leads to Nostra.</Typography>}
                </Grid>

                <Grid xs={12}>
                    <FormControl>
                        <FormLabel >Import Type</FormLabel>
                        <RadioGroup
                            row
                            name="import-type"
                            value={session.importType}
                            onChange={(e) => ExcelImportStore.update(s => { s.session.importType = e.target.value })}
                        >
                            <FormControlLabel value="ImportOnly" control={<Radio />} label="Import Only" />
                            <FormControlLabel value="ImportToSprint" control={<Radio />} label="Assign to Sprint" />
                        </RadioGroup>
                    </FormControl>
                </Grid>

                <Grid xs={12}>
                    <TextField size="small" fullWidth label="Import Name" error={session.nameError} value={session.name} onChange={(e) => ExcelImportStore.update(s => { s.session.name = e.target.value })} />
                </Grid>

                <Grid xs={12}>
                    <FormControl size='small' fullWidth error={session.customerError} disabled={importing}>
                        <InputLabel>Customer</InputLabel>
                        <Select label="Customer" value={session.customerId} onChange={(e) => ExcelImportStore.update(s => { s.session.customerId = e.target.value })}>
                            {customers.map(item => <MenuItem value={item.value}>{item.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Grid>

                {session.importType === 'ImportToSprint' && <>
                    <Grid xs={12}>
                        <FormControl size='small' fullWidth error={session.sprintError && !_.isEmpty(session.customerId)} disabled={_.isEmpty(session.customerId)}>
                            <InputLabel>Sprint</InputLabel>
                            <Select label="Sprint" value={session.sprintId} onChange={(e) => ExcelImportStore.update(s => { s.session.sprintId = e.target.value })}>
                                {customerSprints.map(item => <MenuItem value={item.value}>{item.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid xs={12}>
                        <FormControl size='small' fullWidth error={session.cadenceError && !_.isEmpty(session.sprintId)} disabled={_.isEmpty(session.sprintId)}>
                            <InputLabel>Cadence</InputLabel>
                            <Select label="Cadence" value={session.cadenceId} onChange={(e) => ExcelImportStore.update(s => { s.session.cadenceId = e.target.value })}>
                                {sprintCadences.map(item => <MenuItem value={item.value}>{item.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid xs={12}>
                        <CustomDatePicker label="Start Date" value={session.startDate} onChange={(value) => ExcelImportStore.update(s => { s.session.startDate = value })} error={session.startDateError} />
                    </Grid>
                </>}

                {/*                {unmappedColumns.length > 0 && <PasteErrorDialog missingFields={unmappedColumns} onClose={() => { }} />}*/}
            </Grid>
        </AutoLayout>
    )
}

export { ExcelImportDetails }
export default ExcelImportDetails